import { useQuery } from '@tanstack/react-query';

import { useAuthSession } from '@/features/auth/useAuthSession';
import { fetchProfileRole } from '@/services/profile';

/**
 * Показывать ли пункт «Админка».
 *
 * Это вопрос интерфейса, а не прав: каждую административную операцию
 * проверяет сервер отдельно. Прямой заход на /admin у постороннего
 * закончится отказом от сервера, а не пустым экраном.
 */
export function useIsAdmin(): boolean {
  const { status, session } = useAuthSession();

  const role = useQuery({
    queryKey: ['profile-role', session?.user.id ?? null],
    queryFn: fetchProfileRole,
    enabled: status === 'ready',
  });

  return role.data === 'admin';
}
